import { useTheme } from 'styled-components';
import { getSpacingToken } from '@optimus-web/common';

export const useDrawerHeight = (): `${number}%` => {
    const theme = useTheme();
    const topHeightOffset = getSpacingToken('300')({ theme });
    const drawerPaddingBottom = getSpacingToken('300')({ theme });

    const originalHeight = visualViewport?.height ?? 500;
    const calculatedHeight = originalHeight - (topHeightOffset + drawerPaddingBottom);
    const drawerHeightPercentage = Math.floor((calculatedHeight / originalHeight) * 100);

    return `${drawerHeightPercentage}%`;
};
